import fullcycleURL from "../../../../../docs/assets/qualtrics-1.jpg";
import halfcycleURL from "../../../../../docs/assets/qualtrics-2.jpg";
import * as React from 'react';
export default {
  fullcycleURL,
  halfcycleURL,
  React
};